import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


export const getMetricas = async () => {
  const respuesta = await PrivateInterceptor(`Base/IT/Metricas`, "GET");
  return respuesta;
};

export const GuardarMetrica = (Datos) => {
  const respuesta = PrivateInterceptor("Base/IT/Metricas/GuardarMetrica", "POST", {Datos});
  return respuesta;
};

export const EditarMetrica = (Datos) => {
  const respuesta = PrivateInterceptor("Base/IT/Metricas/EditarMetrica", "POST", {Datos});
  return respuesta;
};

export const getRegistroMetricas = async () => {
  const respuesta = await PrivateInterceptor(`Base/IT/Metricas/Registro`, "GET");
  return respuesta;
};

export const getRegistroMetricasPorFecha = async (data) => {
  const respuesta = await PrivateInterceptor(`Base/IT/Metricas/Registro/MetricasPorFecha`, "POST", data);
  return respuesta;
};

export const getRegistroMetricasPorUsuario = async (data) => {
  const respuesta = await PrivateInterceptor(`Base/IT/Metricas/Registro/MetricasPorUsuario`, "POST", data);
  return respuesta;
};

export const GuardarRegistroMetrica = (Datos) => {
  const respuesta = PrivateInterceptor("IT/Metricas/GuardarRegistroMetrica", "POST", {Datos});
  return respuesta;
};